import React from "react";
import ProfileCard from "pages/Profile/components/common/ProfileCard";

interface Props {
  isEdit?: boolean;
}

const TrainingSection = ({ isEdit }: Props) => {
  return (
    <ProfileCard className="dark:text-white/90" isEdit={isEdit}>
      <h2 className="text-m uppercase dark:text-white">Training</h2>

      <p className="text-s">
        BFA in Theater Performance, Juilliard School. Additional training: Lee
        Strasberg Theatre Institute, Meisner Technique certified.
      </p>
    </ProfileCard>
  );
};

export default TrainingSection;
